import reducer from "./reducers";

import * as labtestSampleAction from "./actions";

export { labtestSampleAction };

export default reducer;
